// The finite presentation vocabulary shared by transport validation and rendering.
export const SUPPORTED_MOBILITY_SECTIONS = Object.freeze([
  "headline",
  "summary_table",
  "domains",
  "metrics",
  "groups",
  "charts",
  "recommendations",
  "fim",
  "longevity",
  "remarks",
  "explanations",
  "partner_summary",
]);
